import {Component, HostListener, Inject, OnInit} from '@angular/core';
import {MatButton} from "@angular/material/button";
import {
  MAT_DIALOG_DATA,
  MatDialogActions, MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {NgForOf, NgIf} from "@angular/common";
import {FormBuilder, ReactiveFormsModule} from "@angular/forms";
import {BroadcastsService} from "../../services/broadcasts.service";
import {UtilService} from "../../services/util.service";
import {Broadcast} from "../../model/broadcast/broadcast";
import {MatSelectModule} from "@angular/material/select";
import {MatIcon, MatIconModule} from "@angular/material/icon";
import {Player} from "../../model/broadcast/player";
import {CdkDragDrop, DragDropModule, moveItemInArray} from "@angular/cdk/drag-drop";

@Component({
  selector: 'app-manual-lineups-dialog',
  imports: [
    MatButton,
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    MatTab,
    MatTabGroup,
    NgForOf,
    NgIf,
    ReactiveFormsModule,
    MatDialogClose,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatIcon,
    MatIconModule,
    DragDropModule
  ],
  templateUrl: './manual-lineups-dialog.component.html',
  styleUrl: './manual-lineups-dialog.component.scss'
})
export class ManualLineupsDialogComponent implements OnInit {
  homeRoster: Player[] = [];
  awayRoster: Player[] = [];
  positions: {value: number, viewValue: string}[] = [];
  selectedHomePitcher: Player = null;
  selectedAwayPitcher: Player = null;
  homePitcherPosition: number = 1;
  awayPitcherPosition: number = 1;
  homePitcherPositionDisabled: boolean = true;
  awayPitcherPositionDisabled: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<ManualLineupsDialogComponent>,
    public broadcastsServise: BroadcastsService,
    public utilService: UtilService,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public broadcast: Broadcast,
  ) {
    // Initialize positions array
    for (let i = 1; i <= 11; i++) {
      this.positions.push({
        value: i,
        viewValue: this.utilService.positionToLabel(i)
      });
    }

    // Add DP option
    this.positions.push({
      value: -1,
      viewValue: 'DP'
    });
  }

  // Properties to track key sequence
  private keySequence: string = '';
  private keySequenceTimer: any = null;
  private readonly KEY_SEQUENCE_TIMEOUT = 1500; // 1 second timeout for key sequence

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {

    // Reset the timer if it exists
    if (this.keySequenceTimer) {
      clearTimeout(this.keySequenceTimer);
    }

    // Add the key to the sequence if it's a letter or number
    if (/^[a-zA-Z0-9-]$/.test(event.key)) {
      this.keySequence += event.key.toLowerCase();

      // Set a timer to reset the sequence after the timeout
      this.keySequenceTimer = setTimeout(() => {
        this.keySequence = '';
      }, this.KEY_SEQUENCE_TIMEOUT);

      // Check if the sequence matches our pattern
      this.processKeySequence();
    } else {
      // Reset the sequence for other keys
      this.keySequence = '';
    }
  }

  private processKeySequence(): void {
    // Check for home team pattern: h followed by numbers
    if (this.keySequence.match(/^h\d{2}(\d|-)$/)) {
      const playerNumber = parseInt(this.keySequence.substring(1, 3), 10);
      const positionPart: string = this.keySequence.substring(3);
      let playerPosition: number;
      if (positionPart === '-') {
        playerPosition = -1;
      } else if (positionPart === '0') {
        playerPosition = 11;
      } else {
        playerPosition = parseInt(positionPart, 10);
      }      this.selectPlayerByNumber(playerNumber, playerPosition,false); // false = home team
      this.keySequence = ''; // Reset sequence after processing
    }
    // Check for away team pattern: a followed by numbers
    else if (this.keySequence.match(/^a\d{2}(\d|-)$/)) {
      const playerNumber = parseInt(this.keySequence.substring(1, 3), 10);
      const positionPart: string = this.keySequence.substring(3);
      let playerPosition: number;
      if (positionPart === '-') {
        playerPosition = -1;
      } else if (positionPart === '0') {
        playerPosition = 11;
      } else {
        playerPosition = parseInt(positionPart, 10);
      }
      this.selectPlayerByNumber(playerNumber, playerPosition,true); // true = away team
      this.keySequence = ''; // Reset sequence after processing
    }
  }

  private selectPlayerByNumber(playerNumber: number, position: number, away: boolean): void {

    const teamRoster: Player[] = this.broadcast.fullRosters.filter(p => p.teamGuid == (away ? this.broadcast.config.awayConfig.id : this.broadcast.config.homeConfig.id) && p.number !== undefined);
    // Find the player with the matching number
    const player: Player =  teamRoster.find(p => p.number === playerNumber);
    if (player) {
      if (away) {
        this.addPlayerToAwayLineup(player, position);
      } else {
        this.addPlayerToHomeLineup(player, position);
      }
      console.log(`Selected ${away ? 'away' : 'home'} player #${playerNumber}: ${player.name}`);
    } else {
      console.log(`No ${away ? 'away' : 'home'} player found with number ${playerNumber}`);
    }
  }

  ngOnInit(): void {
    // Initialize manualLineups if it doesn't exist
    if (!this.broadcast.manualLineups) {
      this.broadcast.manualLineups = {
        homeLineup: [],
        awayLineup: []
      };
    } else {
      // Ensure arrays exist
      if (!this.broadcast.manualLineups.homeLineup) {
        this.broadcast.manualLineups.homeLineup = [];
      }
      if (!this.broadcast.manualLineups.awayLineup) {
        this.broadcast.manualLineups.awayLineup = [];
      }
    }

    // Check for DP in lineups and update pitcher position options
    this.updateHomePitcherPositionOptions();
    this.updateAwayPitcherPositionOptions();

    // Split roster into home and away teams
    console.log('full roster', this.broadcast.fullRosters);
    if (this.broadcast.fullRosters) {
      this.homeRoster = this.broadcast.fullRosters.filter(
        player => player.teamGuid == this.broadcast.config.homeConfig.id
      ).sort((a, b) => {
        // Sort by number (convert to number to ensure proper numeric sorting)
        return (Number(a.number) || 0) - (Number(b.number) || 0);
      });
      console.log('home roster', this.homeRoster);
      this.awayRoster = this.broadcast.fullRosters.filter(
        player => player.teamGuid == this.broadcast.config.awayConfig.id
      ).sort((a, b) => {
        // Sort by number (convert to number to ensure proper numeric sorting)
        return (Number(a.number) || 0) - (Number(b.number) || 0);
      });
    }

    // Initialize selected pitchers
    // Find the original player objects in the roster arrays that match the pitcher objects
    if (this.broadcast.manualLineups.homePitcher) {
      this.selectedHomePitcher = this.homeRoster.find(
        player => player.guid === this.broadcast.manualLineups.homePitcher.guid
      ) || null;
    } else {
      this.selectedHomePitcher = null;
    }

    if (this.broadcast.manualLineups.awayPitcher) {
      this.selectedAwayPitcher = this.awayRoster.find(
        player => player.guid === this.broadcast.manualLineups.awayPitcher.guid
      ) || null;
    } else {
      this.selectedAwayPitcher = null;
    }
  }

  addPlayerToHomeLineup(player: Player, position: number): void {
    if (!player || !position) {
      return; // Don't add if player or position is not selected
    }

    if (!this.broadcast.manualLineups.homeLineup) {
      this.broadcast.manualLineups.homeLineup = [];
    }
    const playerCopy = {...player};
    playerCopy.position = position;
    playerCopy.batting = true;

    this.broadcast.manualLineups.homeLineup.push(playerCopy);

    // Update pitcher position options after adding player
    this.updateHomePitcherPositionOptions();
  }

  addPlayerToAwayLineup(player: Player, position: number): void {
    if (!player || !position) {
      return; // Don't add if player or position is not selected
    }

    if (!this.broadcast.manualLineups.awayLineup) {
      this.broadcast.manualLineups.awayLineup = [];
    }
    const playerCopy = {...player};
    playerCopy.position = position;
    playerCopy.batting = true;

    this.broadcast.manualLineups.awayLineup.push(playerCopy);

    // Update pitcher position options after adding player
    this.updateAwayPitcherPositionOptions();
  }

  removePlayerFromHomeLineup(index: number): void {
    this.broadcast.manualLineups.homeLineup.splice(index, 1);
    // Update pitcher position options after removing player
    this.updateHomePitcherPositionOptions();
  }

  removePlayerFromAwayLineup(index: number): void {
    this.broadcast.manualLineups.awayLineup.splice(index, 1);
    // Update pitcher position options after removing player
    this.updateAwayPitcherPositionOptions();
  }

  setHomePitcher(player: Player, position?: number): void {
    this.selectedHomePitcher = player;
    if (player) {
      const pitcherCopy = {...player};

      // Use provided position or the calculated position
      pitcherCopy.position = position !== undefined ? position : this.homePitcherPosition;

      this.broadcast.manualLineups.homePitcher = pitcherCopy;
    } else {
      this.broadcast.manualLineups.homePitcher = null;
    }
  }

  setAwayPitcher(player: Player, position?: number): void {
    this.selectedAwayPitcher = player;
    if (player) {
      const pitcherCopy = {...player};

      // Use provided position or the calculated position
      pitcherCopy.position = position !== undefined ? position : this.awayPitcherPosition;

      this.broadcast.manualLineups.awayPitcher = pitcherCopy;
    } else {
      this.broadcast.manualLineups.awayPitcher = null;
    }
  }

  dropHomeLineup(event: CdkDragDrop<Player[]>): void {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(this.broadcast.manualLineups.homeLineup, event.previousIndex, event.currentIndex);
    }
  }

  dropAwayLineup(event: CdkDragDrop<Player[]>): void {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(this.broadcast.manualLineups.awayLineup, event.previousIndex, event.currentIndex);
    }
  }

  update(): void {
    this.broadcastsServise.updateManualLineups(this.broadcast).then(() => {
      this.dialogRef.close('update');
    });
  }

  // Check if DP is present in home lineup and update pitcher position options
  updateHomePitcherPositionOptions(): void {
    const hasDp = this.broadcast.manualLineups?.homeLineup?.some(player => player.position === -1);
    this.homePitcherPositionDisabled = !hasDp;

    if (hasDp) {
      // Find the unoccupied position (either 1 or 10 for pitcher/flex)
      const positions = this.broadcast.manualLineups.homeLineup.map(player => player.position);
      for (let i = 1; i <= 9; i++) {
        if (!positions.includes(i)) {
          this.homePitcherPosition = i;
          break;
        }
      }
    } else {
      // If no DP, set position to 1 (pitcher)
      this.homePitcherPosition = 1;
    }

    // Update the pitcher position if it exists
    if (this.broadcast.manualLineups?.homePitcher) {
      this.broadcast.manualLineups.homePitcher.position = this.homePitcherPosition;
    }
  }

  // Check if DP is present in away lineup and update pitcher position options
  updateAwayPitcherPositionOptions(): void {
    const hasDp = this.broadcast.manualLineups?.awayLineup?.some(player => player.position === -1);
    this.awayPitcherPositionDisabled = !hasDp;

    if (hasDp) {
      // Find the unoccupied position (either 1 or 10 for pitcher/flex)
      const positions = this.broadcast.manualLineups.awayLineup.map(player => player.position);
      for (let i = 1; i <= 9; i++) {
        if (!positions.includes(i)) {
          this.awayPitcherPosition = i;
          break;
        }
      }
    } else {
      // If no DP, set position to 1 (pitcher)
      this.awayPitcherPosition = 1;
    }

    // Update the pitcher position if it exists
    if (this.broadcast.manualLineups?.awayPitcher) {
      this.broadcast.manualLineups.awayPitcher.position = this.awayPitcherPosition;
    }
  }
}
